"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MirrorHorizontal = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17,9 L17,16.015966 C17,16.5574815 17.4523405,17.007983 18.0059191,17.007983 L20.9940809,17.007983 C21.5578453,17.007983 22,16.567143 22,16.015966 L22,9 C22,8.4584845 21.5476595,8.00798298 20.9940809,8.00798298 L18.0059191,8.00798298 C17.4421547,8.00798298 17,8.44882302 17,9 Z M16,9 C16,7.89983938 16.8865548,7.00798298 18.0059191,7.00798298 L20.9940809,7.00798298 C22.1019194,7.00798298 23,7.90815915 23,9 L23,16.015966 C23,17.1161266 22.1134452,18.007983 20.9940809,18.007983 L18.0059191,18.007983 C16.8980806,18.007983 16,17.1078068 16,16.015966 L16,9 Z M1,9 C1,7.89983938 1.88655484,7.00798298 3.00591905,7.00798298 L5.99408095,7.00798298 C7.10191945,7.00798298 8,7.90815915 8,9 L8,16.015966 C8,17.1161266 7.11344516,18.007983 5.99408095,18.007983 L3.00591905,18.007983 C1.89808055,18.007983 1,17.1078068 1,16.015966 L1,9 Z M11.5,2 L12.5,2 L12.5,22 L11.5,22 L11.5,2 Z" })));
};
MirrorHorizontal.displayName = 'MirrorHorizontal';
exports.default = MirrorHorizontal;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MirrorHorizontal.js.map